import { IOptionProps } from '@pnld/components-web'

import {
  DeedType,
  EducationStage,
  LegacyDeedType,
  Status,
} from '@/types/processing'

// Só os tipos de obra que o backend aceita na criação (SPA-283 removeu
// Obras EJA daqui). Usar em qualquer form/validação de criação.
export const DEED_TYPE_LABEL: Record<DeedType, string> = {
  [DeedType.OBRAS_DIDATICAS]: 'Obras Didáticas',
  [DeedType.OBRAS_PEDAGOGICAS]: 'Obras Pedagógicas',
  [DeedType.OBRAS_LITERARIAS]: 'Obras Literárias',
}

export const deedTypeOptions: IOptionProps[] = Object.entries(
  DEED_TYPE_LABEL
).map(([value, label]) => ({ value: Number(value), label }))

// Inclui o legado — para exibir/filtrar processamentos já existentes que
// ainda têm nu_deed_type=4. Nunca usar nas opções do form de criação.
export const LEGACY_DEED_TYPE_LABEL: Record<LegacyDeedType, string> = {
  [LegacyDeedType.OBRAS_EJA]: 'Obras EJA (legado)',
}

export const DEED_TYPE_LABEL_WITH_LEGACY: Record<
  DeedType | LegacyDeedType,
  string
> = {
  ...DEED_TYPE_LABEL,
  ...LEGACY_DEED_TYPE_LABEL,
}

export const EDUCATION_STAGE_LABEL: Record<EducationStage, string> = {
  [EducationStage.EDUCACAO_INFANTIL]: 'Educação Infantil',
  [EducationStage.ENSINO_FUNDAMENTAL_ANOS_INICIAIS]:
    'Ensino Fundamental (Anos Iniciais)',
  [EducationStage.ENSINO_FUNDAMENTAL_ANOS_FINAIS]:
    'Ensino Fundamental (Anos Finais)',
  [EducationStage.ENSINO_MEDIO]: 'Ensino Médio',
  [EducationStage.EJA]: 'EJA',
}

export const educationStageOptions: IOptionProps[] = Object.entries(
  EDUCATION_STAGE_LABEL
).map(([value, label]) => ({ value: Number(value), label }))

export const STATUS_LABEL: Record<Status, string> = {
  [Status.PENDENTE]: 'Pendente',
  [Status.PROCESSANDO]: 'Processando',
  [Status.CONCLUIDO]: 'Concluído',
  [Status.FALHOU]: 'Falha',
}
